// add function for numbers to to round to however many places you provide
//only rounds as needed. Does not add decimal places for whole numbers
export const decimalRoundHelper = (num, places = 2) => {
  places = Math.pow(10, places);
  return Math.round(num * places) / places;
};

export function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

export function get_change(current, previous) {
  if (current === previous) {
    return 0;
  }
  return Math.round(
    (Math.abs(current - previous) / ((current + previous) / 2)) * 100,
    2
  );
}

export function calculateLegendLabels(sliderValue, scenario) {
  let percentChange;
  if (scenario === "DCP Cuts") {
    percentChange = get_change(sliderValue, 1300000);
  } else {
    percentChange = get_change(sliderValue, 700000);
  }
  const difference = percentChange / 5;
  const legendLabels = [0];
  let current = 0;
  for (let i = 0; i < 5; i++) {
    legendLabels.push(decimalRoundHelper((current += difference), 2));
  }
  return legendLabels;
}
